import React from "react"
import { css } from "styled-components"
import Divider from "../../atoms/divider"
import { Block, Spacer } from "../../atoms/layout-primitives"
import { BlogGrid } from "../../atoms/layout-primitives/grid"
import VariantContainer from "../../atoms/variant-container"
import { BT } from "../../styles/blog-typography"

interface IListingHeaderProps {
  title: string
  subtitle: string
}

/**
 * Template for a listing page's header
 * @param title - the title
 * @param subtitle - the subtitle (generally, the amount of content)
 */
const ListingHeader = ({ title, subtitle }: IListingHeaderProps) => {
  return (
    <BlogGrid>
      <Block>
        <VariantContainer
          variants={[
            css`
              display: inline;
              ${BT.sm.h1`500`};
              padding-right: 16px;
            `,
            css`
              ${BT.md.h1`500`};
            `,
            css`
              ${BT.lg.h1`500`};
            `,
          ]}
        >
          {title}
        </VariantContainer>
        <VariantContainer
          variants={[
            css`
              display: inline;
              ${BT.sm.info`400`};
              font-size: 16px;
              opacity: 0.45;
            `,
          ]}
        >
          {subtitle}
        </VariantContainer>
      </Block>
      <Spacer height={{ sm: "16px" }} />
      <Divider />
      <Spacer height={{ sm: "24px" }} />
    </BlogGrid>
  )
}

export default ListingHeader
